"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../../axios-client/axios-client.service");
var user_const_1 = require("./user.const");
/**
 * PaymentsUserService
 * @class
 */
var PaymentsUserService = /** @class */ (function () {
    function PaymentsUserService() {
    }
    /**
     * Returns an array of payment methods for a given user(`userUuid`)
     * @param userUuid {string}
     * @returns UserPaymentMethod[]
     */
    PaymentsUserService.prototype.getUserPaymentMethods = function (userUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_const_1.PAYMENTS_USER_ENDPOINT.getUserPaymentMethods
            .replace('{{version}}', version)
            .replace('{{userUuid}}', userUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Adds a new payment method (`data`) to a given user(`userUuid`)
     * @param userUuid {string}
     * @param data UserPaymentMethod
     * @returns
     */
    PaymentsUserService.prototype.postPaymentMethod = function (userUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_const_1.PAYMENTS_USER_ENDPOINT.postPaymentMethod
            .replace('{{version}}', version)
            .replace('{{userUuid}}', userUuid);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Adds a new payment method (`data`) to a given user(`userUuid`)
     * @param userUuid {string}
     * @param data <UserPaymentMethod>
     * @returns
     */
    PaymentsUserService.prototype.patchPaymentMethod = function (userUuid, methodUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_const_1.PAYMENTS_USER_ENDPOINT.patchPaymentMethod
            .replace('{{version}}', version)
            .replace('{{userUuid}}', userUuid)
            .replace('{{methodUuid}}', methodUuid);
        return axios_client_service_1.axiosClientInstance.patch(url, data);
    };
    /**
     * Links a new payment method (`data`) to a given profile(`userProfileUuid`)
     * @param userProfileUuid {string}
     * @param data Partial<PaymentMethod>
     * @returns
     */
    PaymentsUserService.prototype.putLinkPaymentMethodToUser = function (userProfileUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_const_1.PAYMENTS_USER_ENDPOINT.putLinkPaymentMethodToUser
            .replace('{{version}}', version)
            .replace('{{userProfileUuid}}', userProfileUuid);
        return axios_client_service_1.axiosClientInstance.put(url, data);
    };
    return PaymentsUserService;
}());
/**
 * External PaymentsUserService Class Instance
 * @namespace
 */
exports.paymentsUser = new PaymentsUserService();
